import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const TENANTS_API_URL = '/api/v2/tenants';

@Injectable()
export class TenantsBackend {
  constructor(private http: HttpClient) {}

  getTenant(tenantName: string) {
    return this.http.get(`${TENANTS_API_URL}/${tenantName}`);
  }

  postTenant(body: { tenant: any; account: any; token: any }) {
    return this.http.post(TENANTS_API_URL, body);
  }

  postAdminToken(token: string) {
    return this.http.post(`${TENANTS_API_URL}/admin/token`, { token });
  }

  postTenantsLoginToken({ email }: { email: string }) {
    return this.http.post(`${TENANTS_API_URL}/login-token`, { email });
  }
}
